import { downloadBlob } from 'cng-common/helpers/io'
import { NotificationController } from 'core-components/library/popup'
import { Rest } from 'core/classes/http'
import settings from 'src/config/settings'

import { IExportReportPptxPayload } from '../model/types/pptxExport/IExportReportPptxPayload'

export const exportReportsPptx = async (
  payload: IExportReportPptxPayload,
  extra: Record<string, string>
) => {
  const serviceUrl = settings.httpsServices.partner360
  const url = `${serviceUrl}/api/v0/reporting/exportDashboard`

  const fileName = `${extra.baseName} - ${extra.category} - ${payload.fYear} - ${payload.rtm}.pptx`

  try {
    const blobResponse = await Rest.post({
      url,
      payload,
    })

    downloadBlob(fileName, blobResponse)

    return {
      isSuccess: true,
    }
  } catch (e) {
    NotificationController.showError({ message: 'Unable to export' })
    return {
      isSuccess: false,
    }
  }
}
